module.exports = __webpack_public_path__ + "assets/images/baa2f8071345d454682f8341d07a34f6.png";